import { Component } from 'react'
import { DeviceNameHOC, TrackingHOC } from 'hocs'
import { formatContentType } from 'helpers/utils'
import InternalLink from 'components/InternalLink'

const NavigationHOC = (WrappedComponent, options) => {
  class Navigation extends Component {
    componentName = WrappedComponent.name.replace('Container', '')

    renderItemList = (items, options = {}) =>
      items.map((item, index) => {
        const deviceId = options.deviceId || item.deviceId
        const url = `/${item.contentType}/${item.contentId}?device=${deviceId}`
        const handleClick = this.trackClick.bind(
          this,
          item.contentType,
          item.contentId
        )

        return (
          <li key={`${item.contentId}${index}`}>
            <InternalLink to={url} onClick={handleClick}>
              {options.showType && (
                <span>{formatContentType(item.contentType)}: </span>
              )}

              <span>{item.contentTitle}</span>
              {options.showDevice && (
                <span> {this.props.deviceName(deviceId)}</span>
              )}
            </InternalLink>
          </li>
        )
      })

    trackClick = (type, pk) => {
      this.props.createEvent({
        category: 'navigation',
        data: { link_to: `/${type}/${pk}`, source: this.componentName }
      })
    }

    render() {
      const props = { ...this.props, renderItemList: this.renderItemList }
      return <WrappedComponent {...props} />
    }
  }

  return TrackingHOC(DeviceNameHOC(Navigation))
}

export default NavigationHOC
